import { B2bCompanyDocumentDetails } from '@Common/types/bo/b2b/companies';

export const documentsTranslations = {
  fields: {
    id: 'ID',
    document_url: 'URL',
    document_name: 'Name',
    document_comment: 'Comment',
    type: 'Type',
    task_id: 'Task ID',
    co_sepa_mandate_id: 'Sepa Mandate ID',
    is_archived: 'Archived',
    created_at: 'Created at',
    updated_at: 'Updated at',
    is_generated: 'Generated',
    source: 'Source',
    company_id: 'Company ID',
    b2b_campaign_id: 'Operation ID',
    savings_funds_request_id: 'Savings Funds Request ID',
  } satisfies Record<keyof B2bCompanyDocumentDetails, string>,
};
